<template>
    <div v-if="visible" class="recharge-dialog-overlay">
        <div class="recharge-dialog">
            <div class="recharge-dialog-header">
                <h3>虚拟豆余额不足</h3>
                <button class="close-btn" @click="close">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div class="recharge-dialog-content">
                <div class="icon-container">
                    <i class="fas fa-coins"></i>
                </div>
                <p class="message">您的虚拟豆余额不足，无法完成当前操作</p>
                <p class="sub-message">请选择充值套餐</p>

                <div v-if="loading" class="loading-container">
                    <i class="fas fa-spinner fa-spin"></i>
                    <p>加载中...</p>
                </div>

                <div v-else-if="error" class="error-container">
                    <p>{{ error }}</p>
                    <button class="retry-btn" @click="fetchRechargeRules">重试</button>
                </div>

                <div v-else class="recharge-rules-container">
                    <div v-for="rule in rechargeRules" :key="rule.id" class="recharge-rule-item"
                        :class="{ 'selected': selectedRuleId === rule.id }" @click="selectRule(rule.id)">
                        <div class="rule-amount">
                            <span class="coin-amount">{{ rule.coinAmount }}</span>
                            <span class="coin-label">虚拟豆</span>
                        </div>
                        <div class="rule-price">¥{{ rule.cashAmount }}</div>
                    </div>
                </div>
                <!-- <div style="display: flex; justify-content: center; margin-top: 10px;">
                    <span style="text-align: center; font-size: 14px; ">注：改图一次，消耗<span style="color:coral"> {{cost}} </span>个虚拟豆</span>
                </div> -->
            </div>

            <div class="recharge-dialog-footer">
                <button class="cancel-btn" @click="close">取消</button>
                <button class="recharge-btn" @click="handleRecharge" :disabled="!selectedRuleId || loading">
                    立即充值
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from '@/utils/request'

export default {
    name: 'RechargeDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        returnUrl: {
            type: String,
            default: ''
        },
        cost: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            rechargeRules: [],
            loading: false,
            error: null,
            selectedRuleId: null,
            orderNo: null
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.fetchRechargeRules()
            }
        }
    },
    methods: {
        close() {
            this.$emit('close')
            // 重置状态
            this.selectedRuleId = null
        },
        async fetchRechargeRules() {
            this.loading = true
            this.error = null

            try {
                const response = await request('/api/coin/recharge/rule/list')
                if (response.ok) {
                    this.rechargeRules = response.data.filter(rule => rule.status === 1).sort((a, b) => a.sort - b.sort)
                } else {
                    this.error = response.msg || '获取充值规则失败'
                }
            } catch (error) {
                console.error('获取充值规则失败:', error)
                this.error = '网络错误，请稍后重试'
            } finally {
                this.loading = false
            }
        },
        selectRule(id) {
            this.selectedRuleId = id
        },
        async handleRecharge() {
            if (!this.selectedRuleId) {
                this.$message.warning('请选择充值套餐')
                return
            }

            // 获取当前URL作为返回地址
            const path = window.location.href
            let returnUrl = path;
            returnUrl = decodeURIComponent(returnUrl);

            // 确保returnUrl包含完整的域名和端口
            if (!returnUrl.startsWith('http') && !returnUrl.startsWith('https')) {
                returnUrl = `${window.location.origin}${returnUrl.startsWith('/') ? '' : '/'}${returnUrl}`;
            }
            console.log('returnUrl: ', returnUrl)
            returnUrl = 'http://keyanzz.com'

            // 获取订单号
            try {
                const response = await request('/api/payment/generateOrderNo')
                if (response.ok && response.data) {
                    this.orderNo = response.data
                    this.processPayment(returnUrl)
                } else {
                    this.$message.error(response.msg || '获取订单号失败')
                }
            } catch (error) {
                console.error('获取订单号失败:', error)
                this.$message.error('网络错误，请稍后重试')
            }
        },
        async processPayment(returnUrl) {
            if (!this.orderNo) {
                this.$message.error('订单号获取失败，请重试')
                return
            }

            try {
                const selectedRule = this.rechargeRules.find(rule => rule.id === this.selectedRuleId)
                console.log(selectedRule)

                const payResponse = await request('/api/payment/coin/purchase', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ruleId: this.selectedRuleId,
                        orderNo: this.orderNo,
                        returnUrl: encodeURIComponent(returnUrl)
                    })
                })

                if (payResponse.ok) {
                    const tempDiv = document.createElement('div')
                    tempDiv.innerHTML = payResponse.data

                    const form = tempDiv.querySelector('form')
                    if (form) {
                        form.target = '_self'
                        document.body.appendChild(form)
                        form.submit()
                    } else {
                        this.$message.error('未找到有效的支付表单')
                    }
                } else {
                    this.$message.error(payResponse.msg || '支付请求失败')
                }
            } catch (error) {
                console.error('处理支付请求失败:', error)
                this.$message.error('网络错误，请稍后重试')
            }
        }
    }
}
</script>

<style scoped>
.recharge-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.recharge-dialog {
    background: white;
    border-radius: 8px;
    width: 450px;
    max-width: 90%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.recharge-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
}

.recharge-dialog-header h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
}

.close-btn {
    background: transparent;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: #999;
}

.recharge-dialog-content {
    padding: 30px 20px;
    text-align: center;
}

.icon-container {
    margin-bottom: 20px;
}

.icon-container i {
    font-size: 48px;
    color: #fad012;
}

.message {
    font-size: 16px;
    color: #333;
    margin-bottom: 8px;
}

.sub-message {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
}

.recharge-rules-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
    margin-top: 20px;
}

.recharge-rule-item {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 12px;
    width: calc(33.33% - 10px);
    cursor: pointer;
    transition: all 0.3s ease;
}

.recharge-rule-item:hover {
    border-color: #FF7043;
    transform: translateY(-2px);
}

.recharge-rule-item.selected {
    border: 2px solid #FF7043;
    background-color: rgba(255, 112, 67, 0.05);
}

.coin-amount {
    font-size: 18px;
    font-weight: bold;
    color: #333;
}

.coin-label {
    font-size: 12px;
    color: #666;
    margin-left: 4px;
}

.rule-price {
    margin-top: 8px;
    font-size: 14px;
    color: #FF7043;
}

.loading-container {
    padding: 20px;
    text-align: center;
}

.loading-container i {
    font-size: 24px;
    color: #FF7043;
    margin-bottom: 10px;
}

.error-container {
    padding: 20px;
    text-align: center;
    color: #f44336;
}

.retry-btn {
    margin-top: 10px;
    padding: 6px 12px;
    background: #f5f5f5;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.recharge-dialog-footer {
    display: flex;
    justify-content: flex-end;
    padding: 16px 20px;
    border-top: 1px solid #f0f0f0;
    gap: 12px;
}

.cancel-btn {
    padding: 8px 16px;
    background: #f5f5f5;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    color: #666;
}

.recharge-btn {
    padding: 8px 16px;
    background: #FF7043;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    color: white;
}

.recharge-btn:hover {
    background: #F4511E;
}

.recharge-btn:disabled {
    background: #ccc;
    cursor: not-allowed;
}
</style>